/* * 评论列表 * 作者：高苗飞 */
<template>
  <div class="ui-comment">
    <div class="comment-send jrm-border-1px jrm-border-bottom activitylistStyle">
      <div class="comment-flex comment-left"><span @click="cancel">取消</span></div>
      <div class="comment-flex comment-right"><span @click="send">发布</span></div>
    </div>
    <textarea v-model="talkMsg" ref="textarea" placeholder="发布评论" maxlength="500"></textarea>
  </div>
</template>

<script>
import request from '@/util/request';
import { shareInit, HideShare } from '@/util/share';
import { genLinkBySSR } from '@/util/common';
import { messages } from '@/config';

export default {
  name: 'TalkPage',
  created() {},
  data() {
    return {
      talkMsg: '',
      isSendRequesting: false
    };
  },
  mounted() {
    let _href = '';
    _href = genLinkBySSR('activity');

    const defaultOption = {
      shareURL: _href,
      shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
      shareTitle: messages.shareTitle,
      shareDesc: messages.shareDesc,
      shareChannels: ['0', '1', '3']
    };
    shareInit(defaultOption);
    HideShare({ title: '评论', moreItem: false, hideTools: false, backColor: '#ffffff', textColor: 2 });
  },
  methods: {
    send() {
      this.$refs.textarea.blur();
      const activityId = +this.$route.query.activityId || 0;
      const me = this;
      if (this.talkMsg.length < 1) {
        this.$toast.show({ text: '评论内容不能为空' });
        return;
      }

      if (this.isSendRequesting) {
        return;
      }
      this.isSendRequesting = true;

      request.addComment({
        data: {
          content: this.talkMsg,
          activityId: activityId,
          deviceId: 'test deviceId'
        },
        success: rs => {
          const stt = setTimeout(() => {
            clearTimeout(stt);
            this.isSendRequesting = false;
          }, 1000);

          if (rs.issuccess == '1') {
            this.$toast.show({ text: '评论成功' });
            this.talkMsg = '';
            setTimeout(() => {
              me.$toast.hide();
              me.cancel();
            }, 500);
          }
        },
        error: msg => {
          const stt = setTimeout(() => {
            clearTimeout(stt);
            this.isSendRequesting = false;
          }, 1000);
          clearInterval(this.interval);
          this.$toast.show({ text: msg });
          this.focusStatus = false;
        }
      });
    },
    cancel() {
      try {
        $('textarea,input').blur();
      } catch (error) {
        console.log(error);
      }

      setTimeout(() => {
        this.$router.go(-1);
      }, 450);
    }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>
<style lang="scss">
@import './../scss/mixin.scss';
.ui-comment {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  textarea {
    position: absolute;
    width: 100%;
    height: $rem420;
    padding: $rem32;
    font-size: $rem32;
    color: #333333;
    line-height: $rem48;
    resize: none;
    placeholder {
      color: #999999;
      font-size: $rem32;
    }
  }
  .comment-send {
    width: 100%;
    padding: $rem16 $rem32;
    display: table;
    height: $rem100;
    line-height: $rem100;
  }
  .comment-flex {
    display: table-cell;
  }
  .comment-right {
    text-align: right;
    float: right;
    color: #c29451;
  }
  .comment-left {
    text-align: left;
    float: left;
  }
}
</style>
